const toQueryString = params => {
  const str = [];

  const addKey = (key, value) => {
    str.push(`${key}=${value}`);
  };

  Object.keys(params).forEach(param => {
    const key = encodeURIComponent(param);
    if (Array.isArray(params[param])) {
      // turn a: [1, 2] into a=1&a=2
      params[param].forEach(val => {
        addKey(key, val);
      });
    } else {
      const value = encodeURIComponent(params[param]);
      addKey(key, value);
    }
  });
  return str.join('&');
};

export default toQueryString;
